import styled from 'styled-components';

export const FechamentoContainer = styled.div`
  border: 1px solid #EBEBEB;
  border-left: 4px solid #0090D3;
  border-radius: 16px;
  background-color: #F9FBFD;
  padding: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.02);
`;

export const FechamentoHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  padding-bottom: 12px;
  border-bottom: 1px solid #EBEBEB;
`;

export const HeaderPriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeaderPriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > div:first-child, input {
    max-width: 170px;
  }
`;

/* Tabela de itens: header e linhas compartilham o MESMO template de colunas —
 * números comparáveis ficam alinhados verticalmente (tabular-nums, direita). */
export const TableScroll = styled.div`
  overflow-x: auto;
`;

export const ROW_COLS = 'minmax(260px, 1fr) 72px 140px 32px';

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: ${ROW_COLS};
  gap: 8px;
  align-items: center;
  min-width: 520px;
`;

export const ColHead = styled(RowGrid)`
  padding: 0 14px;

  span {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94A3B8;
    text-align: right;
  }

  span:first-child {
    text-align: left;
  }
`;

export const RowsList = styled.div`
  margin-top: 6px;
`;

export const ItemRowCard = styled.div`
  background-color: #FFFFFF;
  border: 1px solid #EBEBEB;
  border-radius: 10px;
  min-width: 860px;

  & + & {
    margin-top: 8px;
  }
`;

export const ItemRow = styled(RowGrid)`
  padding: 10px 14px;
  min-width: 0;
`;

export const ItemName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #475569;

  strong {
    color: #0f172a;
    font-weight: 600;
  }
`;

export const Num = styled.span<{ strong?: boolean; muted?: boolean }>`
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 13.5px;
  color: ${({ strong, muted }) => (strong ? '#0f172a' : muted ? '#94A3B8' : '#475569')};
  font-weight: ${({ strong }) => (strong ? 700 : 400)};
`;

export const ExpandButton = styled.button<{ isOpen?: boolean }>`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #E2E8F0;
  background: ${({ isOpen }) => (isOpen ? '#EFF6FF' : '#FFFFFF')};
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  justify-self: end;

  &:hover {
    border-color: #0090D3;
    color: #0090D3;
  }
`;

/* Breakdown: os subitens que justificam o Preço Cadastrado, em leitura. */
export const Breakdown = styled.div`
  border-top: 1px dashed #E2E8F0;
  padding: 10px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

/* Zebra: associa descrição ↔ valor mesmo com a linha larga (pedido do Gabriel 16/07). */
export const BreakdownRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 13px;
  color: #475569;
  padding: 5px 8px;
  border-radius: 6px;

  &:nth-child(odd) {
    background: #F1F5F9;
  }
`;

export const BreakdownIndex = styled.span`
  flex-shrink: 0;
  min-width: 28px;
  font-size: 12px;
  color: #94A3B8;
  font-variant-numeric: tabular-nums;
`;

export const TypeChip = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  background: #F1F5F9;
  border-radius: 999px;
  padding: 1px 8px;
`;

export const BreakdownDesc = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BreakdownFormula = styled.span`
  color: #94A3B8;
  flex-shrink: 0;
`;

export const BreakdownValue = styled.span`
  margin-left: auto;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
`;

export const PriceFacts = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px 28px;
  padding: 2px 8px 10px;
  border-bottom: 1px solid #E2E8F0;
`;

export const PriceFact = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  color: #475569;

  b {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94A3B8;
  }

  em {
    font-style: normal;
    font-variant-numeric: tabular-nums;
  }
`;

export const GradeBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 8px;
`;

export const GradeTitle = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8;
  padding: 0 8px 2px;
`;

export const GradeRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 13px;
  color: #475569;
  padding: 5px 8px;
  border-radius: 6px;

  &:nth-of-type(odd) {
    background: #F1F5F9;
  }
`;

export const GradeVariant = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GradeFormula = styled.span`
  color: #94A3B8;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
`;

export const GradeValue = styled.span`
  margin-left: auto;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
`;

export const GradeWarning = styled.span`
  font-size: 12px;
  color: #B45309;
  padding: 4px 8px 0;
`;

export const AdjustLink = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  border: none;
  background: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0090D3;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyState = styled.p`
  margin: 4px 0;
  font-size: 13.5px;
  color: #94A3B8;
`;

export const DistributeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  background-color: #FFFFFF;
  color: #0090D3;
  border: 1px solid #0090D3;
`;
